// Reactive phone-viewport detector. Phone = `<768px`, matching the
// Tailwind `md:` breakpoint used throughout the app. Mirrors the
// `prefers-color-scheme` pattern in App.tsx: single `matchMedia`
// subscription, listener on `change`, cleanup on unmount.

import { useEffect, useState } from "react";

const QUERY = "(max-width: 767.99px)";

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const apply = () => setIsMobile(mql.matches);
    apply();
    mql.addEventListener("change", apply);
    return () => mql.removeEventListener("change", apply);
  }, []);

  return isMobile;
}
